import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import { confirmEmail } from '../../store/reducers/SignUp/signupSlice';
import Button from '../../components/Button/Button';
import { Routes as RoutesEnum } from '../../constants/routes';
const ConfirmRegistration = () => {
    const dispatch = useAppDispatch();
    const { search } = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const error = useAppSelector((state) => state.signup.error);
    useEffect(() => {
        if (!error && token) {
            dispatch(confirmEmail(token));
        }
    }, [navigate, error, dispatch, token]);
    return (_jsx("div", { children: _jsxs(_Fragment, { children: [_jsx("div", { children: error }), _jsx(Button, { text: `Try to sign in again`, type: 'NavLink', to: RoutesEnum.LOGIN })] }) }));
};
export default ConfirmRegistration;
